import { Callout } from '../../../../../../components';
import Layout from '../../Layout';

const { Section } = Layout;

export const SetupIpaProductsSegmentationCallout = () => {
  return (
    <Section.Root>
      <Callout variant="warning" size="sm">
        As modificações realizadas até as 22h serão aplicadas na próxima integração de dados. Após esse horário, elas refletem na integração do dia seguinte.
      </Callout>
    </Section.Root>
  );
};
